import { render, staticRenderFns } from "./ElementOtherConfig.vue?vue&type=template&id=84fccc70"
import script from "./ElementOtherConfig.vue?vue&type=script&lang=js"
export * from "./ElementOtherConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports